import api from '.';
import { PipingWorkType } from '../pages/MasterData/PipingWorkType/pipingWorkTypeSlice';

interface ReturnTypePipingWorkType {
  data: PipingWorkType[];
}

export async function getPipingWorkTypes(): Promise<ReturnTypePipingWorkType> {
  const { data } = await api.get('/piping-work-types');

  return data;
}
